import { Injectable } from '@angular/core';
import { ClaimsUtility } from '@wedecide/models';

@Injectable({
  providedIn: 'root',
})
export class AuthClaimsService extends ClaimsUtility {}
